import React, {createContext, useContext} from "react";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link2 from '@material-ui/core/Link';
import {IconButton} from "@material-ui/core";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {Link, useHistory} from "react-router-dom";

export interface BreadCrumbLink {
    text: string,
    link: string
}

export interface iBreadCrumbProps {
    links?: BreadCrumbLink[],
    setLinks?: (links: BreadCrumbLink[]) => void
    /** When set, shown on the same row as breadcrumbs (e.g. campaign name on overview). */
    headingTitle?: string | null,
    setHeadingTitle?: (title: string | null) => void,
}

export const BreadCrumbContext = createContext<iBreadCrumbProps>({});

export default function WithBreadCrumb({children}: { children: React.ReactNode }) {
    const history = useHistory();

    const {links, headingTitle} = useContext(BreadCrumbContext);
    const showInlineTitle = Boolean(headingTitle && headingTitle.trim());

    return <>
        <div className="page-breadcrumb-bar">
            <IconButton
                type="button"
                className="page-breadcrumb-bar__back"
                aria-label="Go back"
                size="small"
                onClick={() => {
                    if (links && links.length > 0) {
                        history.push(links[0].link);
                    } else {
                        history.goBack();
                    }
                }}
            >
                <ArrowBackIcon fontSize="small"/>
            </IconButton>
            <Breadcrumbs
                className="page-breadcrumb-bar__breadcrumbs"
                aria-label="breadcrumb"
                separator="/"
            >
                {
                    links && links.map((link, index) => {
                        return <Link2
                            component={Link}
                            className="page-breadcrumb-bar__crumb-link"
                            key={index}
                            to={link.link}
                        >
                            {link.text}
                        </Link2>
                    })
                }
            </Breadcrumbs>
            {showInlineTitle ? (
                <>
                    <span className="page-breadcrumb-bar__title-rule" aria-hidden/>
                    <h1 className="page-breadcrumb-bar__title" data-tut="reactour__state">
                        {headingTitle}
                    </h1>
                </>
            ) : null}
        </div>
        {children}
    </>
}
